const DownloadIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66992 13.333L13.3359 13.333V8H14.6699V14.667L1.33594 14.667L1.33594 8H2.66992L2.66992 13.333ZM11.9453 7.14551L9.11719 9.97461H8.1748L8.1748 9.03125L11.0029 6.20312L11.9453 7.14551ZM7.77441 9.02344L7.77441 9.9668L6.83203 9.9668L4.00391 7.1377L4.94629 6.19531L7.77441 9.02344ZM8.6709 7.55371L8.00391 8.19824L7.33789 7.55371L7.33789 1.53125L8.6709 1.53125V7.55371Z"
        fill="#444446"
      />
    </svg>
  )
}

export default DownloadIcon
